<template>
  <!-- Report Type List Modal -->
  <b-modal
    id="report-view-list-modal"
    ref="report-view-list-modal"
    centered
    title="Report View"
    ok-title="Ok"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @hidden="resetModal"
    @ok="setReportView"
  >
    <b-row>
      <b-col
        sm="12"
        class="mb-1"
      >
        <b-form-group
          label="Report View List"
        >
          <v-select
            v-model="selectedReportView"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="reportViewOptions"
            label="name"
            value="id"
            placeholder="Select Report View"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import useReportsView from '@/views/admin/reports-v2/reports-view/useReportsView'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,

    vSelect,
  },
  data() {
    return {
      selectedReportView: null,
      reportViewOptions: [],
    }
  },
  async created() {
    await this.fetchReportViewsList().then(res => {
      this.reportViewOptions = res
      if (this.$route.query.report_view_name) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedReportView = this.reportViewOptions.filter(item => item.name === this.$route.query.report_view_name)[0]
        this.setReportView()
      }
    })
  },
  setup() {
    const {
      fetchReportViewsList,
    } = useReportsView()

    return {
      fetchReportViewsList,
    }
  },
  methods: {
    resetModal() {
      this.selectedReportView = null
    },
    setReportView() {
      this.$emit('setReportView', this.selectedReportView)
    },
  },
}
</script>
